import {
  Command,
  CommandEmpty,
  CommandList,
} from '@repo/videa-components/src/ui/command';

import type {
  ZuubOnboardingStatusResponse,
  ZuubPayer,
} from '@/@types/zuub/contracts';

import { PayerListItem } from './PayerListItem';

interface PayerListProps {
  payers: ZuubPayer[];
  selectedPayerId?: number | null;
  testingPayerIds: Set<number>;
  payerStatusData?: Record<string, ZuubOnboardingStatusResponse>;
  loadingStates: Record<string, boolean>;
  onPayerClick: (payerId: number) => void;
  onGoToPortal: (portalUrl: string | undefined) => void;
}

export const PayerList = ({
  payers,
  selectedPayerId,
  testingPayerIds,
  payerStatusData,
  loadingStates,
  onPayerClick,
  onGoToPortal,
}: PayerListProps) => {
  return (
    <Command
      className="vai-flex-1 vai-bg-transparent vai-border-0 vai-overflow-hidden"
      onMouseLeave={(e) => {
        // Clear selection when mouse leaves the command area
        const commandElement = e.currentTarget;
        const selectedItems = commandElement.querySelectorAll(
          '[data-selected="true"]',
        );
        selectedItems.forEach((item) => {
          item.removeAttribute('data-selected');
        });
      }}
    >
      <CommandList className="vai-max-h-full vai-overflow-y-auto vai-p-3">
        <CommandEmpty>No payers found.</CommandEmpty>
        {payers.map((payer) => {
          const isSelected = selectedPayerId === payer.id;
          const payerStatus = payerStatusData?.[payer.id.toString()];
          const isActivelyTesting = testingPayerIds.has(payer.id);
          const isLoading = loadingStates?.[payer.id.toString()] ?? false;

          return (
            <PayerListItem
              key={payer.id}
              payer={payer}
              isSelected={isSelected}
              payerStatus={payerStatus}
              isActivelyTesting={isActivelyTesting}
              isLoading={isLoading}
              onSelect={() => onPayerClick(payer.id)}
              onGoToPortal={onGoToPortal}
            />
          );
        })}
      </CommandList>
    </Command>
  );
};
